import React from 'react'
import { Subscribe } from 'unstated'
import CourseContentStore from '../Store/CourseContentStore'
import Chapter from './Chapter'

const Lessons = () => (
  <Subscribe to={[CourseContentStore]}>
    {({ state }) => {
      return (
        <div className='chapters'>
          {state.chapters.map((chapter, index) => (
            <Chapter chapter={chapter} index={index} state={state} />
          ))}
        </div>
      )
    }}
  </Subscribe>
)

export default Lessons
